'use strict';

let _ = require('lodash');

let Factory = require('./../index');
let RuleComponentFactory = require('./../RuleComponent/index');
let Rule = require('./../../Rule/index');

class RuleFactory extends Factory {
    /**
     * Creates a valid rule given the configuration
     * @param  {Object} config The configurations to use to build the rule
     * @return {Object} A rule class object.
     */
    static create(config) {
        Factory._validate(config);

        config.ruleComponents = buildRuleComponents(config);
        return new Rule(config);
    }
}

module.exports = RuleFactory;

function buildRuleComponents(config) {
    return _.map(config.ruleComponents, (componentConfig) => {
        return RuleComponentFactory.create(componentConfig);
    });
}
